import React, { useEffect, useState } from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { Translate } from '../../../Share/components';
import './style.scss';
import AboutAITolk from './AboutAITolk';
import { connect } from 'react-redux';
import { fetchContactPersons, fetchLicenceTypes } from '../../actions/user';
import UserInstruction from './UserInstruction';
import ManageUsers from './ManageUsers';
import ManageLicenseInstruction from './ManageLicenseInstruction';
import { useLocation, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { FETCH_LICENSE_USERS_SUCCESS } from '../../actions/ActionTypes';

function AITolkUser({
  fetchLicenceTypes = () => { },
  onGetContactPersons = () => { },
  updateLicenseUsers = () => { },
}) {
  const location = useLocation();

  const navigate = useNavigate();
  const [selectedTabIndex, setSelectedTabIndex] = useState(
    location.state?.tabIndex || 0,
  );

  const handleTabSelect = index => {
    navigate('/ai-tolk', {
      state: { tabIndex: index, licenseIdentifier: null },
    });
    updateLicenseUsers();
  };

  useEffect(() => {
    document.title = `AI-Tolk - TFV Kundportal`;
    fetchLicenceTypes();
    onGetContactPersons();
  }, []);

  return (
    <div className="tv-aiTalk__wrapper">
      <Tabs
        className="tv-aiTalk__tabs-wrapper"
        selectedIndex={selectedTabIndex}
        onSelect={handleTabSelect}
      >
        <div className="tv-aiTalk__tab-list-wrapper">
          <TabList>
            <Tab tabIndex="0">
              <div className="tv-aiTalk__tab-text-main">
                <Translate content="aiTalk.information" />
              </div>
            </Tab>
            <Tab tabIndex="0">
              <div className="tv-aiTalk__tab-text-main">
                <Translate content="aiTalk.manageLicense" />
              </div>
            </Tab>
            <Tab tabIndex="0">
              <div className="tv-aiTalk__tab-text-main">
                <Translate content="aiTalk.userInstruction" />
              </div>
            </Tab>
          </TabList>

          {selectedTabIndex === 1 && <ManageLicenseInstruction />}
        </div>

        <TabPanel className="react-tabs__tab-panel px-0">
          <AboutAITolk />
        </TabPanel>

        <TabPanel className="react-tabs__tab-panel px-0">
          <ManageUsers />
        </TabPanel>

        <TabPanel className="react-tabs__tab-panel px-0">
          <UserInstruction />
        </TabPanel>
      </Tabs>
    </div>
  );
}

AITolkUser.prototype = {
  fetchLicenceTypes: PropTypes.func,
  onGetContactPersons: PropTypes.func,
  updateLicenseUsers: PropTypes.func,
};

const mapDispatchToProps = dispatch => ({
  fetchLicenceTypes: () => {
    dispatch(fetchLicenceTypes());
  },
  onGetContactPersons: () => {
    dispatch(fetchContactPersons());
  },
  updateLicenseUsers: () => {
    dispatch({
      type: FETCH_LICENSE_USERS_SUCCESS,
      licenseUsers: [],
    });
  },
});

export default connect(null, mapDispatchToProps)(AITolkUser);
